import { render, staticRenderFns } from "./y_choose_area.vue?vue&type=template&id=2fda92d2&scoped=true&"
import script from "./y_choose_area.vue?vue&type=script&lang=js&"
export * from "./y_choose_area.vue?vue&type=script&lang=js&"
import style0 from "./y_choose_area.vue?vue&type=style&index=0&id=2fda92d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda92d2",
  null
  
)

export default component.exports